import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ManualPropertyAdditionForm } from "./manual-property-addition-form";

interface ManualPropertyInputDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ManualPropertyAdditionDialog = ({
  open,
  onOpenChange,
}: ManualPropertyInputDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle>Add Property to Evaluate</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto px-1">
          <ManualPropertyAdditionForm onComplete={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
